import React, { useState } from 'react';
import { Box, Paper, TextField, Button, Typography, List, ListItem, ListItemText } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios'; // Import axios for API calls

// Import necessary images (adjust paths as needed)


import location from '../images/active_arrow_up.png';
import signal from '../images/single.png'
import network from '../images/network.png'
import battery from '../images/battery.png'
import home from '../images/home.png'
import copyWriting from '../images/copy-writing.png'
import carInsurance from '../images/car-insurance.png'
import world from '../images/world.png'
import family from '../images/family.png'
import retirement from '../images/retirement.png'
import track from '../images/track.png'
import claim from '../images/claim.png'
import image from '../images/image.png'
import menu from '../images/menu.png'
import notifications from '../images/Notifications none.png'
import profilePhoto from '../images/user_profile_pic.png'
import profileMail from '../images/mail-pro.png' 
import profilePhone from '../images/phone_iphone.png' 
import './default.css'

export default function AgentDashboard() {
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredPolicies, setFilteredPolicies] = useState([]); // Stores the list of PolicyHolder objects
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  
  // The 'data' here is the Agent's profile info (passed from Login.js)
  const agentData = location.state; 
  
 

  // Function to navigate back (e.g., to the Login screen or previous context)
  const moveBack = () => {
    navigate('/');
  };

  // Function to navigate to the Policy Holder's Profile
  const handlePolicySelect = (policyHolderData) => {
    // Navigate to the MyProfile screen, passing the selected policy holder's data
    const dataForMyProfile = {
        ...policyHolderData, // Policy Holder's data
        AgentActor: agentData, // The Agent's entire profile
        IsAgentViewing: true, // Optional flag for MyProfile to know the context
    };
    navigate('/myprofile', { state: dataForMyProfile });
  };
  
  // Function to handle the search logic and API call
  const handleSearch = async () => {
      
    if (!searchQuery.trim()) {
        setFilteredPolicies([]);
        return; 
    }

    const companyCode = agentData?.companyCode;
    if (!companyCode) {
        console.error("Agent company code is missing.");
        return;
    }
    setIsLoading(true);
    
    // The request body is now simple: just send the raw text
    const requestBody = { QueryText: searchQuery.trim(),
                          CompanyCode: companyCode }; 
   
    try {
        const API_BASE_URL = 'https://app-selfserve-np-eus.ngsdevapps.net'; 
        // Send the single field 'QueryText'
        const response = await axios.post(`${API_BASE_URL}/SearchPolicyHolders`, requestBody);
        
        setFilteredPolicies(response.data); 

    } catch (error) {
        // ... (error handling) ...
        console.error("Search error:", error.response?.data || error.message);
        setFilteredPolicies([]);
    } finally {
        setIsLoading(false);
    }
  };
  
  return (
    <>
    <div style={{ backgroundColor: "#134c86" ,width: "100%", float: "left" }}>
      
     <div class="Status_bar">
      <div class="time">
        <ul>
          <li>9:40</li>
          <li><img src={location} width="14"/></li>
        </ul>
      </div>
      <div class="network text-align-right">
        <ul>
          <li><img src={signal} width="20"/></li>
          <li><img src={battery} width="24"/></li>
          <li><img src={network} width="28"/></li>
        </ul>
      </div>
    </div>

    
    <div class="trailing_icons">
      <ul>
        <li onClick={moveBack}><img src={menu} width="24"/></li>
        <li>
          <h4> My Profile </h4>
        </li>
        <li><img src={notifications} width="24"/></li>
      </ul>
    </div>

    
    <div class="user_profile">
      <div class="user_pic">
        <img src={profilePhoto}/>
      </div>

      <div class="user_details">
        <ul>
          <li>
            <h1>{agentData.firstName} {agentData.lastName}</h1>
          </li>
          <li class="user_mail"><span><img src={profileMail} width="14"/></span> <span> {agentData.username}
            </span></li>
          <li class="user_mail"><span><img src={profilePhone} width="14"/></span> <span>{agentData.phone1}
            </span></li>
        </ul>
      </div>
    </div>

    
    <div class="content_box">

    <div class="policy_head">
        <h2>Agent Dashboard</h2>
      </div>
    <div class="news_update">
        <Paper sx={{ p: 3, mx: 0 }}> 
            <Typography variant="h6" gutterBottom>
                Search Policy Holder
            </Typography>

            {/* --- 1. SEARCH TEXTFIELD AND BUTTON --- */}
            <Box display="flex" gap={2} mb={3}>
                <TextField
                    fullWidth
                    label="Name or Policy Number"
                    variant="outlined"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onKeyDown={(e) => { if (e.key === 'Enter') handleSearch(); }}
                    // Added sx={{ flexGrow: 1 }} to ensure proper width alignment 
                    sx={{ flexGrow: 1 }} 
                />
                <Button 
                    variant="contained" 
                    onClick={handleSearch}
                    sx={{ minWidth: '100px', height: '56px' }}
                    disabled={isLoading} 
                >
                    {isLoading ? 'SEARCHING' : 'SEARCH'}
                </Button>
            </Box>

            {/* --- 2. POLICY HOLDER RESULTS LIST --- */}
            <List sx={{ maxHeight: 400, overflowY: 'auto' }}>
                
                {isLoading && (
                    <Typography align="center" sx={{ py: 2 }}>
                        Loading results...
                    </Typography>
                )}

                {!isLoading && filteredPolicies.length > 0 ? (
                    filteredPolicies.map((policyHolder, index) => (
                        <ListItem 
                            key={policyHolder.id || index} 
                            button 
                            onClick={() => handlePolicySelect(policyHolder)}
                            divider
                            sx={{ '&:hover': { backgroundColor: '#e8e8e8' } }}
                        >
                            <ListItemText
                                  primary={`${policyHolder.firstName} ${policyHolder.lastName}`}
                                  secondary={`Policy: ${policyHolder.policyNumber || 'N/A'} | ${
                                      policyHolder.email 
                                          ? `Email: ${policyHolder.email}` 
                                          : policyHolder.Username 
                                              ? `Username: ${policyHolder.Username}` 
                                              : 'No Contact Info'
                                  }`}
                            />
                        </ListItem>
                    ))
                ) : (
                    !isLoading && searchQuery && (
                        <Typography color="textSecondary" sx={{ mt: 2 }}>
                            No policies found matching "{searchQuery}".
                        </Typography>
                    )
                )}
                
                {!isLoading && !searchQuery && filteredPolicies.length === 0 && (
                    <Typography color="textSecondary" sx={{ mt: 2 }}>
                        Enter a name or policy number to begin searching.
                    </Typography>
                )}

            </List>
        </Paper>
      </div>

      
      <div class="footer_dark">
        <p>Copyright © 2023 <a href="#">Insuranceworld.com</a> <br/> All rights reserved</p>
      </div>

    </div>
</div>


    </>
  )

  
}